import React from 'react';
import {Slider, useMediaQuery, withStyles} from "@material-ui/core";
import {BP_LARGE} from "Theme/breakpoints";

const LevelBar = withStyles((theme) => {
    const LevelProgressBarSettings = theme.overrides.LevelProgressBar;
    return {
        root: {
            height: 12,
            width: '100%',
            [theme.breakpoints.up(BP_LARGE)]: {
                width: 550,
                marginLeft: 12,
            },
            '& .MuiTab-wrapper': {
                textTransform: 'none',
            },
            '& .MuiSlider-mark': {
                height: 24,
                width: 24,
                borderRadius: '50%',
                marginTop: -6,
                marginLeft: -12,
                [theme.breakpoints.up(BP_LARGE)]: {
                    // marginTop: -8,
                    marginLeft: -6,
                    width: 24,
                    height: 24,
                }
            },
            '& .MuiSlider-root.Mui-disabled': {},
            '& .MuiSlider-rail': {
                opacity: 100,
                backgroundColor: LevelProgressBarSettings.unfilledColor,
            },
            '& .MuiSlider-thumb.Mui-disabled': {
                display: 'none'
            }

        },
        thumb: {
            height: 20,
            width: 20,
            marginTop: -6,
            marginLeft: -10,
            [theme.breakpoints.up(BP_LARGE)]: {
                height: 24,
                width: 24,
            }
        },
        track: {
            height: 12,
            borderRadius: 4,
            background: LevelProgressBarSettings.fillColor,
        },
        rail: {
            height: 12,
            borderRadius: 4,
        },
        mark: {
            backgroundColor: LevelProgressBarSettings.unfilledColor,
        },
        markActive: {
            background: LevelProgressBarSettings.fillColor,
            opacity: 100,
            [theme.breakpoints.up(BP_LARGE)]: {}

        },
        markLabel: {
            color: LevelProgressBarSettings.color,
            opacity: 0.7,
            fontSize: '0.75rem',
            marginTop: 5,
            [theme.breakpoints.up(BP_LARGE)]: {
                fontSize: '1.050rem',
                marginLeft: 18,
                marginTop: 15,
            }
        },
        markLabelActive: {
            opacity: 1,
        },
    }
})(Slider);

export const RewardslevelBar = (props) => {
    const points = props.currentPoints;
    const levels = [
        {min: 0, max: 499, scale: 40, startingPoint: 0},
        {min: 500, max: 4999, scale: 4, startingPoint: 25},
        {min: 5000, max: 19999, scale: 1, startingPoint: 50},
        {min: 20000, max: 99999, scale: 0.25, startingPoint: 75},
        {min: 100000, max: 1000000, scale: 1, startingPoint: 100},
    ];

    const levelSettings = levels.find(l => {
        if (points >= l.min && points <= l.max) {
            return l;
        }
    });

    const currentLevel = ((points / 1000) * levelSettings.scale) + levelSettings.startingPoint;
    const matchesLargeUp = useMediaQuery('(min-width:600px)');

    const marks = [
        {
            value: 0,
            label: matchesLargeUp ? 'Level 1' : 'Lvl 1',
        },
        {
            value: 25,
            label: matchesLargeUp ? 'Level 2' : 'Lvl 2',
        },
        {
            value: 50,
            label: matchesLargeUp ? 'Level 3' : 'Lvl 3',
        },
        {
            value: 75,
            label: matchesLargeUp ? 'Level 4' : 'Lvl 4',
        },
        {
            value: 100,
            label: matchesLargeUp ? 'Level 5' : 'Lvl 5',
        },
    ];

    return (
        <LevelBar
            key={`slider-${currentLevel}`} /* fixed issue */
            disabled
            defaultValue={currentLevel}
            valueLabelDisplay="off"
            steps={100000}
            marks={marks}
        />
    );
}
